<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sShcXY/tc-custom/9781683504931.jpg?1702083864410" alt="This image is the cover for the book Frazzled to Free"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Frazzled to Free
      </h1>
      <p class="bookDescription body article font2">
        <b>Did you become a mom and immediately find that your career no longer works for you? Do you long to be doing something different, but aren’t sure what or how? Or how you’ll even find time and energy to make it happen with such a busy life?</b><p>After more than a decade of personal experience in picking the exact wrong careers, Kayla Berg offers a much easier and simpler way to find soulful, meaningful work that is both a joy to do and works with the demands of family life. Because how you spend your working time matters. If Danielle LaPorte, Martha Beck, and Elisa Romero got together for a wine night and ended up writing a book, Frazzled to Free would have been the result.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kayla Berg
      </h2>
      
      <p class="authorDescription body article">Kayla Berg has had not one but 2.5 career rock bottoms. After deciding that a decade as a soul-numbing corporate drone was all she could handle and that life as a massage therapist wasn’t much better, she gave it all up to follow her dream of becoming an author and life coach. It’s her mission to help other mommas experiencing career dissatisfaction connect to their Soul to find meaningful work lights them up inside. She completed her life coach training with the Martha Beck Institute and is an endorsed Soul’s Calling Coach. She lives in Edmonton, Alberta, Canada, with her husband, their two adorable sons, and their fur-kids, Sadie and Oscar Wilde.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e570260